import { styled, theme } from "../../../../../../styles/stitches.config"
import { Flex } from "../../../../../../components/flex/Flex"

export const ContractSelectionWrapper = styled(Flex, {
  gap: theme.space.s6,
})
export const DisclaimerContainer = styled("div", {
  boxShadow: theme.shadows.default,
  border: "1px solid",
  borderColor: theme.colors.warning,
})

export const BusinessDisclaimerStyled = styled("div", {
  width: "100%",
  display: "flex",
  alignItems: "center",
  padding: theme.space.s4_5,
  flexDirection: "column",
  gap: theme.space.s4,

  "@sm": {
    flexDirection: "row",
    paddingLeft: theme.space.s5,
    gap: "0",
    justifyContent: "space-between",
  },
})
export const HouseholdDisclaimerStyled = styled(Flex, {
  width: "100%",
  position: "relative",
  paddingLeft: theme.space.s6,
  paddingRight: theme.space.s6,
  paddingBottom: theme.space.s8,
  paddingTop: theme.space.s8,

  "@sm": {
    paddingLeft: "87px",
    paddingRight: "45px",
    paddingTop: theme.space.s6,
  },
})
export const BusinessDisclaimerText = styled("span", {
  fontWeight: theme.fontWeights.semiBold,
  fontSize: theme.fontSizes.regular,
  textAlign: "center",
  color: theme.colors.warning,

  "@sm": {
    marginLeft: theme.space.s6,
    textAlign: "left",
  },
})
export const ContractSelectionForm = styled("div", {
  maxWidth: theme.sizes.s105,
  width: "100%",
})

export const ContractDisplayResults = styled(Flex, {
  boxShadow: theme.shadows.light,
  padding: theme.space.s4_5,

  gap: theme.space.s8,
  "@md": {
    gap: theme.space.s13,
  },
})
